import React from "react";
import "./DNAFragment.scss";
import { DNAFragmentValue } from "../../DNA";

interface IProps {
    value: DNAFragmentValue;
}

export function DNAFragment({ value }: IProps) {
    const classes = ['dna-fragment', `fragment-${value}`]
    return (
        <div className={classes.join(' ')} />
    )
}
